<template>
<div class="stream">
  <qr-stream @decode="onDecode" class="mb">
    <div style="color: red;" class="frame"></div>
  </qr-stream>
</div>
</template>
<script>
import { QrStream } from 'vue3-qr-reader';
import { reactive,defineComponent } from 'vue';
export default defineComponent({
  name: 'QrStreamExample',
  components: {
    QrStream
  },
  setup() {
    const state = reactive({
      data: ''
    })
    function onDecode(data) {
      state.data = data;
      window.location.href=data;
      
    }
    return { state,     
      onDecode
    }
  }
});
</script>